<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0">
            <multiselect
              v-model="unidade"
              :options="this.$parent.optionsUnidade"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Unidade"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="tipo_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Tipo de Carga</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="destino"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >	CPF/ CNPJ Destino	</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="origem"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >	CPF/ CNPJ Origem</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="resdespacho"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CPF/ CNPJ Redespacho</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      optionsLivStatus: [],
      status: [],
      optionsUf: [],
      unidade:"",
      tipo_carga:"",
      destino:"",
      origem:"",
      resdespacho:"",
      data_filter: [],
    };
  },
  mounted() {
    this.getStatus();
    this.getUf();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        unidade: this.unidade,
        tipo_carga: this.tipo_carga,
        destino: this.destino,
        origem: this.origem,
        resdespacho: this.resdespacho,
        status: this.status,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.unidade = "";
      this.tipo_carga = "";
      this.destino = "";
      this.origem = "";
      this.resdespacho = "";
      this.status = "";
      this.$events.fire("filter-reset");
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
